import './assets/css/bootstrap-custom.css';
import './assets/css/style.css';
import Routes from './Routes';
// comtext: Path: src/App.js

function App() {
  return <Routes />;
}

export default App;
